import axios from 'axios'
import * as Util from '../util'

const state = {
  selectedLocations: [],
  selectedLocationIds: [],
  results: []
}

const mutations = {
  SEARCH (state, formInput) {
    axios.get(Util.makeAutocompleteUrl('/autocomplete/locations', formInput)).then(function (response) {
      state.results = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  FETCH_LOCATIONS (state, locationIds) {
    axios.get(Util.makeGetByIdUrl('/locations/descriptions', locationIds)).then(function (response) {
      state.selectedLocations = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  ADD_SELECTED_LOCATION_ID (state, locationId) {
    state.selectedLocationIds.push(locationId.toString())
  },

  REMOVE_SELECTED_LOCATION_ID (state, locationId) {
    let index = state.selectedLocationIds.indexOf(locationId.toString())
    if (index > -1) {
      state.selectedLocationIds.splice(index, 1)
    }
  },

  SET_SELECTED_LOCATION_IDS (state, locationIds) {
    state.selectedLocationIds = locationIds.split(',')
  }
}

const actions = {
  search: function ({commit}, formInput) {
    commit('SEARCH', formInput)
  },

  setSelectedLocations: function ({commit}, locationIds) {
    commit('FETCH_LOCATIONS', locationIds)
  },

  setSelectedLocationIds: function ({commit}, locationIds) {
    commit('SET_SELECTED_LOCATION_IDS', locationIds)
  },

  addSelectedLocationId: function ({commit}, locationId) {
    commit('ADD_SELECTED_LOCATION_ID', locationId)
  },

  removeSelectedLocationId: function ({commit}, locationId) {
    commit('REMOVE_SELECTED_LOCATION_ID', locationId)
  }
}

const getters = {
  results: state => state.results,
  selectedLocations: state => state.selectedLocations,
  selectedLocationIds: state => state.selectedLocationIds
}

export const FilterLocations = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/filters/FilterLocations.js